var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNokiaLogowine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-120 -33.71 1040 202.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.52 133.18H0v-131h66.62l76.43 97.8V2.18h38.52v131H116.3L38.52 33.71v99.47m327.35-40.51c0 18.21-3.22 24.49-8.55 30.51-8.17 8.96-20.06 11.66-42.97 11.66h-65.77c-22.91 0-34.82-2.7-42.98-11.66-5.33-6.02-8.55-12.3-8.55-30.51v-50.5c0-18.2 3.22-24.47 8.55-30.5C213.77 2.7 225.67 0 248.58 0h65.77c22.91 0 34.8 2.7 42.97 11.67 5.33 6.03 8.55 12.3 8.55 30.5v50.5m-53.14 8.98c8.8 0 11.9-.52 14.01-2.44 1.97-1.79 2.84-4.1 2.84-11.8V47.43c0-7.7-.87-9.99-2.84-11.79-2.11-1.93-5.21-2.44-14.01-2.44h-62.54c-8.8 0-11.9.51-14 2.44-1.98 1.8-2.85 4.09-2.85 11.79v39.98c0 7.7.87 10.01 2.85 11.8 2.1 1.92 5.2 2.44 14 2.44h62.54M421.85 2.18v131H381.6v-131h40.25m68 0h53.14l-71.72 61.27 80.89 69.73H495.3l-73.45-68.32 68-62.68m69.73 0h40.26v131h-40.26m193.73 0l-11.91-22.82h-77.89l-11.77 22.81h-44.47L678.62 2.18h50.04l71.34 131h-46.69M677.5 81.91h50.05l-25.03-47.43-25.02 47.43",
    fill: "#1c4598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNokiaLogowine);
export default __webpack_public_path__ + "static/media/Nokia-Logo.wine.b9f1b3f06bc0258e6ad76945d3476516.svg";
export { ForwardRef as ReactComponent };